import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import hexRgb from "hex-rgb";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AnchorLink } from "gatsby-plugin-anchor-links";

const FabLink = styled(AnchorLink).attrs(
  ({ bgColor, color, size, padding }) => ({
    bgColor: bgColor || "transparent",
    color: color || "#000",
    size: size,
    padding: padding,
  })
)`
  background-color: ${({ bgColor }) => bgColor};
  color: ${({ color }) => color};
  border: 1px solid;
  border-color: ${({ color }) => color};
  border-radius: 100%;
  margin: 10px 15px;
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  display: flex;
  height: ${({ size }) => size};
  width: ${({ size }) => size};
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-sizing: content-box;
  padding: ${({ padding }) => padding};

  &:hover {
    background-color: ${({ bgColor, color }) =>
      bgColor !== "transparent"
        ? hexRgb(bgColor, { format: "css", alpha: 0.3 })
        : hexRgb(color, { format: "css", alpha: 0.3 })};
    border-color: transparent;
  }
  &:hover svg {
    transform: translateY(30%);
  }
`;
const Icon = styled((props) => <FontAwesomeIcon {...props} />)`
  font-size: ${({ $fontSize }) => $fontSize};
  color: ${({ $color }) => ($color ? $color : "#000")};
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
`;

const RoundIconLink = ({
  link,
  icon,
  textcolor,
  fontSize,
  padding,
  bgColor,
}) => {
  return (
    <>
      <FabLink
        color={textcolor}
        size={fontSize}
        padding={padding}
        to={link}
        bgColor={bgColor}
      >
        <Icon $fontSize={fontSize} $color={textcolor} icon={icon} />
      </FabLink>
    </>
  );
};

RoundIconLink.propTypes = {
  icon: PropTypes.object,
  link: PropTypes.string,
  textcolor: PropTypes.string,
  bgColor: PropTypes.string,
  fontSize: PropTypes.string,
  padding: PropTypes.string,
};

RoundIconLink.defaultProps = {
  icon: "",
  link: "",
  color: "white",
};

export default RoundIconLink;
